import { aiData, selectedAiPage } from '../../stores/ai-page.js';

/**
 * SaveToOptimizely
 * @class
 * @constructor
 * @public
 * @version 1.0.0
 */
class SaveToOptimizely extends HTMLElement {
	constructor() {
		super();

		this.saveData = this.saveData.bind(this);
	}

	/**
	 * Getters
	 */

	/**
	 * @type HTMLButtonElement | null
	 */
	get button() {
		return this.querySelector('button');
	}

	/**
	 * @type boolean | null
	 */
	get aiEnabled() {
		return this.getAttribute('data-ai-enabled') !== 'false';
	}

	/**
	 * connectedCallback
	 * Render html/css & attatch event listeners
	 */
	connectedCallback() {
		if (!this.button?.getAttribute('type')) {
			this.button?.setAttribute('type', 'button');
		}
		this.button?.addEventListener('click', this.saveData);

		this.unsubscribeSelectedAiPage = selectedAiPage.subscribe((id) => {
			if (id) {
				this.button.classList.remove('hidden');
			} else {
				this.button.classList.add('hidden');
			}
		});
	}

	/**
	 * disconnectedCallback
	 * Remove listeners.
	 */
	disconnectedCallback() {
		this.button?.removeEventListener('click', this.saveData);
		this.unsubscribeSelectedAiPage();
	}

	/**
	 * Starts the process to save data to Optimizely.
	 */
	async saveData() {
		this.button.setAttribute('data-loading', 'true');
		const data = aiData.get();
		let json;

		if (!this.aiEnabled) {
			window.location.replace(`/`);
			return;
		}

		try {
			const response = await fetch('/api/save-to-optimizely', {
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
				method: 'POST',
				body: JSON.stringify(data),
			});

			if (response.status > 199 && response.status < 300) {
				json = await response.json();
			} else {
				const text = await response.text();
				console.error(text);
			}

			if (json) {
				this.button.removeAttribute('data-loading');
				try {
					window.location.replace(`/${json[0].routeSegment}/`);
				} catch (error) {
					console.error('Couldnt redirect', error);
				}
			}
		} catch (error) {
			this.button.removeAttribute('data-loading');
			console.error(error);
		}
	}
}

if (customElements.get('save-to-optimizely') === undefined) {
	window.customElements.define('save-to-optimizely', SaveToOptimizely);
}
